import { UserEntity } from './entities/user.entity';
import { AccountEntity } from './entities/account.entity';
import { InitAuthTables1700000000000 } from './migrations/1700000000000-init-auth-tables';
import { AddUserVerifiedAt1700000001000 } from './migrations/1700000001000-add-user-verified-at';
import { CamelCaseToSnakeCase1773650454102 } from './migrations/1773650454102-camel-case-to-snake-case';

export { UserEntity } from './entities/user.entity';
export { AccountEntity } from './entities/account.entity';
export { AccountProvider, AccountType, SOCIAL_PROVIDERS } from './types/account-provider';
export type { LinkedAccount } from './types/account-provider';
export { setMigrationRole } from './migrations/migration-role';

/** Entities for the shared storefront auth schema (users / accounts). */
export const AuthDbEntities = [UserEntity, AccountEntity];

/**
 * Migrations for the shared storefront auth schema. Execution stays on
 * storefront level: each storefront registers these in its own migration
 * DataSource (own credentials) and provides `DB_MIGRATIONS_ROLE`.
 */
export const AuthDbMigrations = [
  InitAuthTables1700000000000,
  AddUserVerifiedAt1700000001000,
  CamelCaseToSnakeCase1773650454102,
];
